import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Avatar } from '@dhl/components'
import { ChevronRightIcon, LogoutIcon, LanguageIcon } from '@dhl-ui/icons'
import { useKeycloakInstance, useProfile } from '@dhl/keycloak'
import { Body1, Box, Grid, H1, H5, List, ListItem, ListItemText, ListItemIcon, Button } from '@dhl-ui/components'
import { links } from '~/AppRoutes'

export const OverviewPage = () => {
  const { logout } = useKeycloakInstance()
  const { data: profile } = useProfile()
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const clickLogout = () => {
    logout({
      redirectUri: `${window.location.protocol}//${window.location.host}`,
    })
  }

  return (
    <>
      <H1>{t('admin.profile.overviewPage.titleText')}</H1>
      {profile && (
        <>
          <Grid container alignItems="center" justifyContent="center" direction="column">
            <Grid>
              <Box mt={2} mb={2}>
                <Avatar isLarge>{`${profile.firstName?.[0]}${profile.lastName?.[0]}`}</Avatar>
              </Box>
            </Grid>
            <Grid>
              <Box mb={1}>
                <H5>
                  {profile.firstName} {profile.lastName}
                </H5>
              </Box>
            </Grid>
            <Grid>
              <Body1>{profile.email}</Body1>
            </Grid>
          </Grid>
          <Box mt={4}>
            <List>
              <ListItem
                Component={Link}
                to={links.languageLink()}
                data-testid="language"
                slotProps={{ secondaryIcon: <ChevronRightIcon /> }}
              >
                <ListItemIcon>
                  <LanguageIcon />
                </ListItemIcon>
                <ListItemText
                  primary={t('admin.profile.overviewPage.languageButton')}
                  secondary={t(`languages.long.${language}`)}
                />
              </ListItem>
            </List>
            <Button sx={{ mt: 4 }} fullWidth onClick={clickLogout} startIcon={<LogoutIcon />}>
              {t('admin.profile.overviewPage.logoutButton')}
            </Button>
          </Box>
        </>
      )}
    </>
  )
}
